import {CustomerAccessLevel} from "../types.domain";
import {RoleAccess} from "../auth-service.domain";


export type CustomerAccessLevelAndRoleAccessValue = {
  customerAccessLevel: CustomerAccessLevel,
  roleAccess: RoleAccess
} | null;

